import React from "react";
import axios from "axios";
import { connect } from "react-redux";
import { reduxForm } from "redux-form";
import { getTotalPayments } from "./util";
import { formatMoney } from "../../util";

import { BASE_URL } from "../../constants";

// Components
import ReservationPage from "./View";
import GreyBackgroundPage from "../../components/GreyBackgroundPage";
import withRedirectToHomePage from "../../components/withRedirectToHomePage";

// Actions
import { sendConfirmationEmail } from "./actions";

class ReservationsPageContainer extends React.Component {
  state = {
    flightInfo: null,
    fetchingFlightLookupInfo: false,
    fetchError: null
  };

  componentDidMount() {
    const { email, orderId } = this.props.reservedTrip;
    const url = `${BASE_URL}/flights/lookup`;
    const self = this;

    // Get bookingId and email from store
    const payload = {
      orderId,
      email
    };

    // Get latest FlightLookup info from PPN
    axios
      .post(url, payload)
      .then(response => {
        const data = response.data;
        self.setState({ flightInfo: data });
        self.setState({ fetchingFlightLookupInfo: false }); // removes spinner
      })
      .catch(err => {
        self.setState({ fetchingFlightLookupInfo: false }); // removes spinner
        self.setState({ fetchError: err }); // removes spinner
        // console.log("err from flight lookup", err);
      });
  }

  render() {
    const props = this.props;
    const { flightInfo } = this.state;
    const airlineContacts =
      flightInfo && Object.values(flightInfo.airlineContact);
    const importantInfoPopupData =
      flightInfo && flightInfo.importantInfoPopupData;

    return (
      <GreyBackgroundPage>
        <ReservationPage
          {...{
            ...props,
            ...props.reservedTrip,
            airlineContacts,
            importantInfoPopupData
          }}
        />
      </GreyBackgroundPage>
    );
  }
}

function mapStateToProps(state) {
  const reservedTrip = state.trips.reservedTrip;
  const redirectToHomePage = !reservedTrip;

  // Redirect to home page if page is entered in incorrect state
  if (redirectToHomePage) return { redirectToHomePage };

  const { tripFinancials, charges, ...rest } = reservedTrip;
  const {
    totalCost,
    ppnBaseFare,
    ppnTaxesAndFees,
    installmentPayment,
    ppnFees,
    fwdlookFees,
    installmentDates,
    downPayment
  } = tripFinancials;
  const totalPayments = getTotalPayments(charges);

  return {
    onSendConfirmationEmail: sendConfirmationEmail,
    reservedTrip: {
      ...rest,
      installmentDates,
      totalCost: formatMoney(totalCost),
      ppnFees: formatMoney(ppnFees),
      ppnBaseFare: formatMoney(ppnBaseFare),
      ppnTaxesAndFees: formatMoney(ppnTaxesAndFees),
      installmentPayment: formatMoney(installmentPayment),
      fwdlookFees: formatMoney(fwdlookFees),
      downPayment: formatMoney(downPayment),
      totalPayments: formatMoney(totalPayments),
      paymentPercentage: formatMoney((totalPayments / totalCost) * 100)
    },
    ...state.reservationPage
  };
}

function mergeProps(stateProps, dispatchProps, ownProps) {
  const {
    reservedTrip: { email, orderId }
  } = stateProps;
  const { dispatch } = dispatchProps;

  return {
    ...ownProps, //provides parent props that have nothing to do with redux-form (in this case, only react-router's history obj).
    ...stateProps, // provides result from mapStateToProps e.g. 'reservedTrip' to component
    onSendConfirmationEmail: () =>
      // dispatch(sendConfirmationEmail({ reservedTrip }))
      dispatch(sendConfirmationEmail({ customerId: email, orderId }))
  };
}

const ReservationsHOC = reduxForm({
  form: "reservations"
})(withRedirectToHomePage(ReservationsPageContainer));

export default connect(
  mapStateToProps,
  null,
  mergeProps
)(ReservationsHOC);



// WEBPACK FOOTER //
// ./src/scenes/ReservationsPage/index.js